/* eslint-disable prettier/prettier */
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { acceptInvitation } from '../../../services/team'

export default function AcceptInvite() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const navigate = useNavigate()
  const calledRef = useRef(false)

  const [state, setState] = useState('loading') // 'loading' | 'success' | 'error'
  const [errorMsg, setErrorMsg] = useState('')
  const [userEmail, setUserEmail] = useState('')

  useEffect(() => {
    if (!token) {
      setState('error')
      setErrorMsg('Ссылка приглашения недействительна.')
      return
    }
    if (calledRef.current) return
    calledRef.current = true

    acceptInvitation(token)
      .then(data => {
        localStorage.setItem('token', data.token)
        localStorage.setItem('user', JSON.stringify(data.user))
        setUserEmail(data.user?.email || '')
        setState('success')
        setTimeout(() => {
          window.location.hash = '#/dashboard/invoices/all'
          window.location.reload()
        }, 3000)
      })
      .catch(err => {
        const msg = err?.response?.data?.error || 'Приглашение не найдено или срок действия истёк.'
        setErrorMsg(msg)
        setState('error')
      })
  }, [token, navigate])

  return (
    <div style={pageStyle}>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes checkPop { 0% { transform: scale(0); opacity: 0; } 70% { transform: scale(1.15); } 100% { transform: scale(1); opacity: 1; } }
      `}</style>
      <div style={cardStyle}>

        {/* Logo */}
        <div style={logoStyle}>
          <div style={logoIconStyle} />
          <span style={logoTextStyle}>AIBuddy CRM</span>
        </div>

        {state === 'loading' && (
          <div style={centerStyle}>
            <div style={spinnerStyle} />
            <h2 style={{ color: '#0f172a', fontSize: 20, fontWeight: 700, margin: '24px 0 8px' }}>
              Активация аккаунта...
            </h2>
            <p style={{ color: '#64748b', fontSize: 14, margin: 0, lineHeight: 1.6 }}>
              Принимаем приглашение и готовим ваш аккаунт.
              <br />Это займёт секунду.
            </p>
          </div>
        )}

        {state === 'success' && (
          <div style={{ ...centerStyle, animation: 'fadeIn 0.4s ease-out' }}>
            <div style={checkIconStyle}>✓</div>
            <h2 style={{ color: '#059669', fontSize: 22, fontWeight: 700, margin: '20px 0 10px' }}>
              Добро пожаловать!
            </h2>
            <p style={{ color: '#475569', fontSize: 15, margin: '0 0 20px', lineHeight: 1.7 }}>
              Ваш аккаунт успешно активирован.
            </p>
            <div style={emailBoxStyle}>
              <span style={{ fontSize: 12, color: '#94a3b8', fontWeight: 500 }}>Письмо с паролем отправлено на</span>
              <br />
              <strong style={{ fontSize: 15, color: '#0f172a' }}>{userEmail}</strong>
            </div>
            <p style={{ color: '#94a3b8', fontSize: 13, margin: '16px 0 0' }}>
              Перенаправляем в панель управления...
            </p>
          </div>
        )}

        {state === 'error' && (
          <div style={{ ...centerStyle, animation: 'fadeIn 0.3s ease-out' }}>
            <div style={errorIconStyle}>⚠️</div>
            <h2 style={{ color: '#1e293b', fontSize: 20, fontWeight: 700, margin: '0 0 10px' }}>
              Не удалось принять приглашение
            </h2>
            <p style={{ color: '#64748b', fontSize: 14, margin: '0 0 28px', lineHeight: 1.6 }}>
              {errorMsg}
            </p>
            <a href="/login" style={linkBtnStyle}>Перейти ко входу</a>
          </div>
        )}
      </div>
    </div>
  )
}

const pageStyle = {
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #f0f4f8 0%, #e2e8f0 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px 16px',
}

const cardStyle = {
  background: '#fff',
  borderRadius: 20,
  padding: '48px 40px',
  width: '100%',
  maxWidth: 440,
  boxShadow: '0 8px 40px rgba(0,0,0,0.10)',
}

const logoStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 12,
  marginBottom: 40,
}

const logoIconStyle = {
  width: 38,
  height: 38,
  background: 'linear-gradient(135deg,#3b82f6,#2563eb)',
  borderRadius: 10,
}

const logoTextStyle = {
  fontSize: 22,
  fontWeight: 700,
  color: '#0f172a',
  letterSpacing: '-0.5px',
}

const centerStyle = {
  textAlign: 'center',
}

const spinnerStyle = {
  width: 48,
  height: 48,
  border: '4px solid #e2e8f0',
  borderTopColor: '#3b82f6',
  borderRadius: '50%',
  animation: 'spin 0.8s linear infinite',
  margin: '0 auto',
}

const checkIconStyle = {
  width: 72,
  height: 72,
  background: 'linear-gradient(135deg,#10b981,#059669)',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 34,
  color: '#fff',
  fontWeight: 700,
  margin: '0 auto',
  animation: 'checkPop 0.4s ease-out',
}

const emailBoxStyle = {
  background: '#f8fafc',
  border: '1px solid #e2e8f0',
  borderRadius: 12,
  padding: '14px 20px',
  display: 'inline-block',
}

const errorIconStyle = {
  fontSize: 52,
  marginBottom: 16,
}

const linkBtnStyle = {
  display: 'inline-block',
  padding: '12px 28px',
  background: 'linear-gradient(135deg,#3b82f6,#2563eb)',
  color: '#fff',
  textDecoration: 'none',
  borderRadius: 12,
  fontSize: 15,
  fontWeight: 700,
}
